<page-grid [gridConfig]="gridConfig"></page-grid>
